import type { WidgetConfig } from './types';

export const getButtonStyles = (config: WidgetConfig): Partial<CSSStyleDeclaration> => ({
  position: 'fixed',
  bottom: config.buttonPosition?.bottom || '20px',
  right: config.buttonPosition?.right || '20px',
  width: config.buttonSize || '60px',
  height: config.buttonSize || '60px',
  borderRadius: '50%',
  backgroundColor: config.buttonColor || '#007bff',
  color: 'white',
  border: 'none',
  cursor: 'pointer',
  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: String(config.zIndex || 9999),
  transition: 'transform 0.2s, box-shadow 0.2s'
});

export const getContainerStyles = (config: WidgetConfig): Partial<CSSStyleDeclaration> => ({
  position: 'fixed',
  bottom: '90px',
  right: '20px',
  width: '100%',
  maxWidth: config.maxWidth || '375px',
  height: config.height || '667px',
  maxHeight: 'calc(100vh - 120px)',
  borderRadius: '12px',
  boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
  overflow: 'hidden',
  zIndex: String(config.zIndex || 9999),
  display: 'none',
  transition: 'opacity 0.3s, transform 0.3s',
  opacity: '0',
  transform: 'translateY(20px)',
  backgroundColor: '#ffffff'
});

export const getIframeStyles = (): Partial<CSSStyleDeclaration> => ({
  width: '100%',
  height: '100%',
  border: 'none',
  borderRadius: '12px'
});

export const applyStyles = (element: HTMLElement, styles: Partial<CSSStyleDeclaration>): void => {
  Object.assign(element.style, styles);
};

